import { cn } from './cn';
import Reveal from './Reveal';

export type Stat = { value: string; label: string };
type Props = { stats: Stat[]; tone?: 'light' | 'dark'; layout?: 'stack' | 'row' | 'grid'; className?: string };

export default function Stats({ stats, tone = 'light', layout = 'stack', className }: Props) {
  const dark = tone === 'dark';
  return (
    <div className={cn(layout === 'row' ? 'grid gap-10 sm:grid-cols-2 lg:grid-cols-4' : layout === 'grid' ? 'grid gap-x-10 gap-y-14 sm:grid-cols-2 lg:grid-cols-3' : 'flex flex-col gap-8', className)}>
      {stats.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.1}>
          <div className={cn('font-display font-bold leading-none', dark ? 'text-[4rem] text-brand md:text-[6rem]' : 'text-[2.5rem] text-brand-dark')}>
            {s.value}
          </div>
          <div className={cn('mt-2 font-medium', dark ? 'text-lg text-white' : 'text-lg text-black')}>{s.label}</div>
        </Reveal>
      ))}
    </div>
  );
}
